import { generateConfidenceColors } from "./generateConfidenceColors";
const primary = "86.133% 0.141 139.549";
const content = "82.901% 0.031 222.959";

export const dimTheme = {
  name: "dim",
  default: false,
  prefersDark: false,
  colorScheme: "dark",
  colors: {
    // Base colors
    "base-100": "30.857% 0.023 264.149",
    "base-200": "28.036% 0.019 264.182",
    "base-300": "26.346% 0.018 262.177",
    "base-content": "82.901% 0.031 222.959",
    
    // Primary colors
    "primary": "86.133% 0.141 139.549",
    "primary-content": "17.226% 0.028 139.549",
    
    // Secondary colors
    "secondary": "73.375% 0.165 35.353",
    "secondary-content": "14.675% 0.033 35.353",
    
    // Accent colors
    "accent": "74.229% 0.133 311.379",
    "accent-content": "14.845% 0.026 311.379",
    
    // Neutral colors
    "neutral": "24.731% 0.02 264.094",
    "neutral-content": "82.901% 0.031 222.959",
    
    // Semantic colors
    "info": "86.078% 0.142 206.182",
    "info-content": "17.215% 0.028 206.182",
    "success": "86.171% 0.142 166.534",
    "success-content": "17.234% 0.028 166.534",
    "warning": "86.163% 0.142 94.818",
    "warning-content": "17.232% 0.028 94.818",
    "error": "82.418% 0.099 33.756",
    "error-content": "16.483% 0.019 33.756",
    
    // Confidence levels
    ...generateConfidenceColors(primary, content, true)
  },
  dimensions: {
    "radius-selector": "1rem",
    "radius-field": "0.5rem",
    "radius-box": "1rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "0",
    "noise": "0"
  }
};
